import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { IGarageVehicleModel } from "../models/garage/garage-vehicle.model";
import { IPaginationRequestBaseModel } from "../models/generic/pagination/pagination-request.base.model";
import { IPaginationResponseModel } from "../models/generic/pagination/pagination-response.base.model";
import { IMarqueDtoModel } from "../models/vehicles/dto/marque-dto.model";
import { EnvironmentService } from "./environment.service";
import { VehicleMapper } from "../mappings/vehicle.mapping";
import { IMarqueModel } from "../models/vehicles/marque.model";
import { ApplicationContextService } from "./application-context.service";

const httpOptionsWithClientId = {
   headers: new HttpHeaders({
     'X-Client-Id':'2FC6E2AC-18D6-462E-A662-FF6BC75968C9',
   })
 };
 
@Injectable({
   providedIn: 'root'
})
export class VehicleService {
   mapper: VehicleMapper;
   constructor(private readonly httpClient: HttpClient, private envService: EnvironmentService, private applicationContext: ApplicationContextService) {
      this.mapper = new VehicleMapper();
   }
 
   private path() {
      if (this.applicationContext.isPublic()) {
         return `${this.envService.settings.publicApiUrl}/Options`;
      }
      return `${this.envService.settings?.apiUrl}/Garages`;
   }

   getAll(paginationModel: IPaginationRequestBaseModel): Observable<IPaginationResponseModel<IGarageVehicleModel>> {
      throw new Error("Method not implemented.");
   }

   populateAvailableYears = (yearsString:string) => {

      let startYear = parseInt(yearsString.slice(0, 4));
      let endYear = parseInt(yearsString.slice(6, 11));
  
      let modelYears: any = [];
  
      if (endYear == startYear) {
        modelYears.push({
          'year': startYear.toString(),
          'value': startYear
        })
        return modelYears;
      } else {
  
        if (isNaN(endYear)) {
          endYear = new Date().getFullYear();
        }
  
        for (let y = startYear; y <= endYear; y++) {
          modelYears.push({
            'year': y.toString(),
            'value': y
          })
          if (y == endYear) {
            return modelYears
          }
        }
      }
    }
  
  
    getOptions = (currentStep:any, selection:any, vehicles:any) => {
      console.log(currentStep)
      console.log(selection)
      console.log(vehicles)
      let options: any = [];
      let filteredResults: any = [];
  
      for (let i = 0; i < vehicles.length; i++) {
  
        let v = vehicles[i];
  
        console.log(v)
  
        if (this.doesVehicleMatchSelection(v, selection, currentStep.step)) {
          filteredResults.push(v);
          if (this.isOptionAlreadyGiven(options, v[selection[currentStep.step].title]) == false) {
            options.push({
              id: v[selection[currentStep.step].title].id,
              title: v[selection[currentStep.step].title].title
            });
            
          }
        }
      }
  
      return of(
        {
          options: options,
          filteredResults: filteredResults
        }
      ).toPromise()
    }
  
    filterVehicles = (currentStep:any, selection:any, vehicles:any) => {
  
      let filteredVehicles: any = [];
      for (let vI = 0; vI < vehicles.length; vI++) {
        let v = vehicles[vI];
        if (this.doesVehicleMatchSelection(v, selection, currentStep.step)) {
          filteredVehicles.push(v)
        }
      }
  
      return of(filteredVehicles);
    }
  
    isOptionAlreadyGiven = (options:any, newOption:any) => {
      if (!options.length) {
        return false;
      }
  
      for (let o = 0; o < options.length; o++) {
        if (options[o].id == newOption.id && options[o].title == newOption.title) {
          return true;
        } else if (o == (options.length - 1)) {
          return false;
        }
      }
  
      return false;
    }
  
    doesVehicleMatchSelection = (vehicle:any, selection:any, step:any) => {
  
      for (let s = step; s >= 0; s--) {
        //selection doesnt have value here
  
        if (
          selection[s].value &&
          vehicle[selection[s].title].title != selection[s].value.title &&
          vehicle[selection[s].title].id != selection[s].value.id//does id match, e.g. range obj on vehicle 
        ) {
          return false;
        } else if (s == 0) {
          return true;
        }
      }
  
      return false
    }

    getMarques = () => {
      return this.httpClient.get(
        `${this.path()}/vehicles?getVehicles=true`, httpOptionsWithClientId
      )
    }

    public getMarque(getVehicles: boolean): Observable<IMarqueModel> {
      const mapper = new VehicleMapper();
      return this.httpClient.get<IMarqueDtoModel>(`${this.path()}/vehicles?getVehicles=${getVehicles}`, httpOptionsWithClientId).pipe(
         map(resultDto => mapper.toApplicationModel(resultDto) as IMarqueModel)
      );
    }
}